import { OperationRequest } from '../operations/operation-request';
import { Routes } from '../routes';
import { Strategy } from './abstract-strategy';

export class ErrorStrat extends Strategy {
    public pathToGo: string;

    public hasCondition(request: OperationRequest): boolean {

      const hasError = request.hasError;
        if (hasError) {
            return true;
        }
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        this.pathToGo = Routes.ERROR;
    }
}
